const FEATURES = [
  {
    icon: 'ri-shield-flash-line',
    title: '海量资源',
    desc: '汇聚全网10万+黑料视频，覆盖娱乐圈、网红圈、综艺圈等热门领域，内容应有尽有。',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速流畅',
    desc: '黑料视频在线观看采用CDN加速技术，无论何时何地都能享受高清流畅的播放体验。',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '一键下载',
    desc: '支持黑料视频下载到本地，手机App和网页端均可使用，随时随地离线观看。',
    color: 'bg-secondary-100 text-secondary-900',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '7x24小时内容追踪，每日更新200+条新鲜黑料视频，确保用户第一时间获取最新内容。',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端覆盖',
    desc: '支持网页端、iOS App、Android App多端访问，官网地址和手机App均可稳定使用。',
    color: 'bg-accent-100 text-accent-700',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">为什么选择黑料视频？五大核心优势为你保驾护航</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((feature, idx) => (
            <div key={idx} className="text-center p-5 md:p-6 bg-background-100 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-200 group">
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl ${feature.color} flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}